import { createFileRoute } from "@tanstack/react-router";
import GhidCumparatori from "@/pages/GhidCumparatori";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/buyer-guide/")({
  head: () => routeHead("/uk/buyer-guide/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <GhidCumparatori />
  );
}
